import './index.less';

import { Button, Modal, Result } from 'antd';
import { useState } from 'react';

import { Agreement } from '../../../features/agreement/agreementSlice';
import AgreementDetailsContent from '../AgreementDetailsContent';

export type AgreementDetailsModalProps = {
  agreement?: Agreement;
  callback?: any;
  agreementNo?: null;
  agreementId?: null;
};

const AgreementDetailsModal: React.FC<AgreementDetailsModalProps> = (
  props: AgreementDetailsModalProps
) => {
  const { agreement, callback, agreementNo, agreementId } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    if (callback) {
      callback();
    }
  };

  return (
    <>
      {agreementNo && (
        <>
          <Button type="link" onClick={showModal}>
            {agreementNo}
          </Button>

          {agreementId && (
            <>
              <Modal
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                footer={null}
              >
                {agreementId ? (
                  <AgreementDetailsContent agreementId={agreementId} modalView={true} />
                ) : (
                  <Result status="404" title="404" subTitle="Sorry, agreement not found." />
                )}
              </Modal>
            </>
          )}
        </>
      )}

      {agreement && (
        <>
          <Button type="link" onClick={showModal}>
            {agreement.agreementNo}
          </Button>
          <Modal
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            width={1000}
            footer={null}
          >
            {agreement.id ? (
              <AgreementDetailsContent
                agreementId={agreement.id}
                modalView={true}
                title="Agreement Details"
              />
            ) : (
              <Result status="404" title="404" subTitle="Sorry, agreement not found." />
            )}
          </Modal>
        </>
      )}
    </>
  );
};

export default AgreementDetailsModal;
